// extracted by mini-css-extract-plugin
module.exports = {"quick-view-button":"QuickView_quick-view-button__5wofb","quick-view-icon":"QuickView_quick-view-icon__cmL_R"};